import { createI18n } from '@nucleus-commerce/i18n';

import abandonedCheckouts from '@/locales/en/abandoned-checkouts.json';
import account from '@/locales/en/account.json';
import activity from '@/locales/en/activity.json';
import analytics from '@/locales/en/analytics.json';
import apiKeys from '@/locales/en/api-keys.json';
import apply from '@/locales/en/apply.json';
import appointments from '@/locales/en/appointments.json';
import attributes from '@/locales/en/attributes.json';
import auctions from '@/locales/en/auctions.json';
import auth from '@/locales/en/auth.json';
import blog from '@/locales/en/blog.json';
import chatSettings from '@/locales/en/chat-settings.json';
import collections from '@/locales/en/collections.json';
import common from '@/locales/en/common.json';
import content from '@/locales/en/content.json';
import conversations from '@/locales/en/conversations.json';
import customers from '@/locales/en/customers.json';
import dashboard from '@/locales/en/dashboard.json';
import dictionary from '@/locales/en/dictionary.json';
import discounts from '@/locales/en/discounts.json';
import docs from '@/locales/en/docs.json';
import draftOrders from '@/locales/en/draft-orders.json';
import errors from '@/locales/en/errors.json';
import feeds from '@/locales/en/feeds.json';
import giftCards from '@/locales/en/gift-cards.json';
import helpCenter from '@/locales/en/help-center.json';
import home from '@/locales/en/home.json';
import importsExports from '@/locales/en/imports-exports.json';
import inventory from '@/locales/en/inventory.json';
import launch from '@/locales/en/launch.json';
import linkTargets from '@/locales/en/link-targets.json';
import markets from '@/locales/en/markets.json';
import media from '@/locales/en/media.json';
import menus from '@/locales/en/menus.json';
import notifications from '@/locales/en/notifications.json';
import orders from '@/locales/en/orders.json';
import organization from '@/locales/en/organization.json';
import pages from '@/locales/en/pages.json';
import paymentMethods from '@/locales/en/payment-methods.json';
import policies from '@/locales/en/policies.json';
import privacyRequests from '@/locales/en/privacy-requests.json';
import productRules from '@/locales/en/product-rules.json';
import productTypes from '@/locales/en/product-types.json';
import production from '@/locales/en/production.json';
import products from '@/locales/en/products.json';
import push from '@/locales/en/push.json';
import redirects from '@/locales/en/redirects.json';
import reports from '@/locales/en/reports.json';
import resourcePickers from '@/locales/en/resource-pickers.json';
import returns from '@/locales/en/returns.json';
import schedules from '@/locales/en/schedules.json';
import seo from '@/locales/en/seo.json';
import shipping from '@/locales/en/shipping.json';
import sizeSets from '@/locales/en/size-sets.json';
import skuRules from '@/locales/en/sku-rules.json';
import social from '@/locales/en/social.json';
import storeCatalog from '@/locales/en/store-catalog.json';
import stores from '@/locales/en/stores.json';
import tax from '@/locales/en/tax.json';
import team from '@/locales/en/team.json';
import tours from '@/locales/en/tours.json';
import webhooks from '@/locales/en/webhooks.json';
import workflows from '@/locales/en/workflows.json';

export const i18n = createI18n({
  resources: {
    en: {
      common,
      abandonedCheckouts,
      account,
      activity,
      analytics,
      apiKeys,
      attributes,
      auctions,
      apply,
      appointments,
      auth,
      blog,
      chatSettings,
      collections,
      content,
      conversations,
      customers,
      dashboard,
      dictionary,
      discounts,
      docs,
      draftOrders,
      errors,
      feeds,
      giftCards,
      helpCenter,
      home,
      importsExports,
      inventory,
      launch,
      linkTargets,
      markets,
      media,
      menus,
      notifications,
      orders,
      organization,
      pages,
      paymentMethods,
      policies,
      privacyRequests,
      production,
      productRules,
      productTypes,
      products,
      skuRules,
      push,
      redirects,
      reports,
      returns,
      schedules,
      seo,
      shipping,
      social,
      sizeSets,
      resourcePickers,
      storeCatalog,
      stores,
      tax,
      team,
      tours,
      webhooks,
      workflows,
    },
  },
  debug: import.meta.env.DEV,
});
